<template>
    <div class="select-button-wrapper">
        <span class="checker">{{ selected ? '◉' : '○' }}</span>
        <button 
            :class="`select-button ${!selected ? 'inactive' : ''} ${border ? 'bordered' : ''}`" 
            :style="cssVars" 
        >
            
            <slot>

            </slot>
            
        </button>
    </div>
</template>


<script>
export default {
    name: "select-button",
    props: ["bgcol", "selected", "border"],

    computed: {
        cssVars() {
            return {
                '--bg-col': this.bgcol
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.select-button-wrapper {
    &.dark-bg {
        button {
            color: white;
        }
    }
}

button {
    position: relative;
    background-color: var(--bg-col);

    &.inactive {
        background-color: unset;
        color: black !important;
        border: 1px solid black;
    }

    padding: 0.7em 1.5em;
    //color: white;
    font-size: 0.8em;
    
    &.bordered {
        border: 1px solid black;
    }

}



.checker {
    margin-right: 0.5em;
}

.select-button-wrapper {
    display: flex;
    align-items: center;
}

</style>